"use client";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import CommonImage from "@/components/common/image/CommonImage";
import { IoChevronDown } from "react-icons/io5";
import InstructorCard from "@/components/common/card/InstructorCard";
import HomePageService from "@/services/api/HomeService";
import { Empty, Spin } from "antd";
import { useSelector } from "react-redux";
import SkeletonInstructorSection from "@/components/common/skeletons/SkeletonInstructorSection";

export default function InstructorSection({instructors=[]}) {
  const setting = useSelector((state) => state.setting.data);

  return (
    <>
    {/* {loading? <SkeletonInstructorSection/> :( */}
   <section className="advisor_section section_padding">
      <div className="container">
        <div className="section_title">
          <h2 className="title">
            <span className="w-8 h-8">
              <CommonImage
                src={"/images/home-page/advisor.avif"}
                className="img-icon"
                alt={"Image"}
              />{" "}
            </span>{" "}
            {setting?.instrucor_title}
          </h2>
          <p className="short-des">{setting?.instrucor_sub_title}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 lg:gap-6 section-content-wrap">
          { instructors.length > 0 ? (
            instructors.map((instructor, index) => (
              <InstructorCard key={index} instructor={instructor} />
            ))
          ) : (
            <div className="col-span-full text-center">
              <Empty />
            </div>
          )}
        </div>
        {instructors.length >= 3 && (
          <div className="text-center md:mt-8 mt-6">
            <Link href="/instructors" className="seemore-btn">
              সকল শিক্ষক দেখো <IoChevronDown />
            </Link>
          </div>
        )}
      </div>
    </section>
    {/* )} */}
    </>
 
  );
}
